export const GLOBAL_CHANGE_SECTION = "globalSetSection";

export const LOGIN = "login";
export const LOGOUT = "logOut";
export const FETCH_USER = "fetchUser";

export const FETCH_TAXONOMIES = "fetchTaxonomies";
export const FETCH_TARGETS = "fetchTargets";

export const FETCH_FOLDERS = "fetchFolders";
export const FOLDER_CREATE = "folderCreate";
export const FOLDER_UPDATE = "folderUpdate";
export const FOLDER_DELETE = "folderDelete";
export const FOLDER_UNSET_CURRENT = "folderUnsetCurrent";

export const FETCH_NOTES = "fetchNotes";
export const NOTE_CREATE = "noteCreate";
export const NOTE_UPDATE = "noteUpdate";
export const NOTE_DELETE = "noteDelete";
export const NOTE_DOWNLOAD = "noteDownload";

export const FETCH_SUBNOTES = "fetchSubnotes";
export const FETCH_NOTE_SUBNOTES = "fetchNoteSubnotes";
export const SUBNOTE_CREATE = "subnoteCreate";
export const SUBNOTE_UPDATE = "subnoteUpdate";
export const SUBNOTE_DELETE = "subnoteDelete";
export const SUBNOTE_DOWNLOAD = "subnoteDownload";

export const RESET_SEARCH = "resetSearch";

export const FETCH_ARTICLES = "fetchArticles";
export const FETCH_ARTICLES_WITH_FILE = "fetchArticlesWithFile";
export const FETCH_MORE_ARTICLES = "fetchMoreArticles";
export const ARTICLE_UPDATE = "articleUpdate";
export const ARTICLE_CURRENT = "articleCurrent";

export const MONITOR_GET_TAGS                 = "monitorGetTags";
export const MONITOR_GET_CONSUMER_INSIGHTS    = "monitorGetConsumerInsights";
export const MONITOR_GET_CONSUMER_GENERATIONS = "monitorGetConsumerGenerations";
export const MONITOR_GET_MARKET_INSIGHTS      = "monitorGetMarketInsights";
export const MONITOR_GET_MARKET_SECTORS       = "monitorGetMarketSectors";
export const MONITOR_GET_GEOLOCALIZATION      = "monitorGetGeolocalization";
export const MONITOR_GET_GENDER               = "monitorGetGender";

export const MONITOR_GET_CUSTOMERS    = "monitorGetCustomers";
export const MONITOR_GET_MARKETS      = "monitorGetMarkets";

export const MONITOR_GET_ALL            = "monitorGetAll";
export const MONITOR_GET_LIST_CONSUMER  = "monitorGetListConsumer";
export const MONITOR_GET_LIST_MARKET    = "monitorGetListMarket";
export const MONITOR_GET                = "monitorGet";
export const MONITOR_CREATE             = "monitorCreate";
export const MONITOR_EDIT               = "monitorEdit";
export const MONITOR_DELETE             = "monitorDelete";

export const MONITOR_DUPLICATE  = "monitorDuplicate";

export const MONITOR_CHAPTER_GET_ALL    = "monitorChapterGetAll";
export const MONITOR_CHAPTER_CREATE     = "monitorChapterCreate";
export const MONITOR_CHAPTER_EDIT       = "monitorChapterEdit";
export const MONITOR_CHAPTER_DELETE     = "monitorChapterDelete";

export const MONITOR_CHAPTER_PUBLISH    = "monitorChapterPublish";
export const MONITOR_CHAPTER_DUPLICATE  = "monitorChapterDuplicate";

export const MONITOR_PARAGRAPH_GET_ALL    = "monitorParagraphGetAll";
export const MONITOR_PARAGRAPH_GET        = "monitorParagraphGet";
export const MONITOR_PARAGRAPH_CREATE     = "monitorParagraphCreate";
export const MONITOR_PARAGRAPH_EDIT       = "monitorParagraphEdit";
export const MONITOR_PARAGRAPH_DELETE     = "monitorParagraphDelete";

export const MONITOR_PARAGRAPH_DUPLICATE  = "monitorParagraphDuplicate";

export const MONITOR_PARAGRAPH_OBJECT_GET_ALL  = "monitorParagraphObjectGetAll";
export const MONITOR_PARAGRAPH_OBJECT_CREATE   = "monitorParagraphObjectCreate";
export const MONITOR_PARAGRAPH_OBJECT_EDIT     = "monitorParagraphObjectEdit";
export const MONITOR_PARAGRAPH_OBJECT_DELETE   = "monitorParagraphObjectDelete";
export const MONITOR_PARAGRAPH_OBJECT_ARCHIVE  = "monitorParagraphObjectArchive";

export const MONITOR_PARAGRAPH_OBJECT_CONTENT_GET     = "monitorParagraphObjectContentGet";
export const MONITOR_PARAGRAPH_OBJECT_CONTENT_CREATE  = "monitorParagraphObjectContentCreate";
export const MONITOR_PARAGRAPH_OBJECT_CONTENT_EDIT    = "monitorParagraphObjectContentEdit";

export const MONITOR_TRASH_GET      = "monitorTrashGet";
export const MONITOR_TRASH_RESTORE  = "monitorTrashRestore";
export const MONITOR_TRASH_DELETE   = "monitorTrashDelete";

export const MONITOR_TRASH_CHAPTER_PARAGRAPH_GET      = "monitorTrashChapterParagraphGet";
export const MONITOR_TRASH_CHAPTER_RESTORE            = "monitorTrashChapterRestore";
export const MONITOR_TRASH_CHAPTER_DELETE             = "monitorTrashChapterDelete";
export const MONITOR_TRASH_PARAGRAPH_RESTORE          = "monitorTrashParagraphRestore";
export const MONITOR_TRASH_PARAGRAPH_DELETE           = "monitorTrashParagraphDelete";
export const MONITOR_TRASH_PARAGRAPH_OBJECT_RESTORE   = "monitorTrashParagraphObjectRestore";
export const MONITOR_TRASH_PARAGRAPH_OBJECT_DELETE    = "monitorTrashParagraphObjectDelete";

export const MONITOR_HISTORY_GET = "monitorsHistoryGet";